import { createFileRoute } from '@tanstack/react-router';
import { Bot, Send } from 'lucide-react';
import { useState } from 'react';
import { Header, PageContainer } from '@/components/layout';
import { Card, CardBody, Button, Input } from '@/components/ui';

export const Route = createFileRoute('/aelita')({
  component: AelitaPage,
});

function AelitaPage() {
  const [message, setMessage] = useState('');
  const [messages, setMessages] = useState<Array<{ role: 'user' | 'assistant'; content: string }>>([
    {
      role: 'assistant',
      content:
        "Hi! I'm Aelita, your AI assistant. I can help you with insights about your projects, team utilization, and more. What would you like to know?",
    },
  ]);

  const handleSend = () => {
    if (!message.trim()) return;

    setMessages((prev) => [...prev, { role: 'user', content: message }]);
    setMessage('');

    // Simulate AI response (to be replaced with actual API call)
    setTimeout(() => {
      setMessages((prev) => [
        ...prev,
        {
          role: 'assistant',
          content:
            "I'm currently in development mode. Soon I'll be able to analyze your project data, provide insights on team utilization, identify risks, and help generate reports. Stay tuned!",
        },
      ]);
    }, 1000);
  };

  return (
    <>
      <Header title="Aelita" subtitle="Your AI-powered assistant for insights and analysis" />
      <PageContainer>
        <div className="max-w-4xl mx-auto">
          <Card className="h-[calc(100vh-220px)] flex flex-col">
            {/* Chat messages */}
            <CardBody className="flex-1 overflow-y-auto space-y-4">
              {messages.map((msg, i) => (
                <div
                  key={i}
                  className={`flex ${msg.role === 'user' ? 'justify-end' : 'justify-start'}`}
                >
                  <div
                    className={`max-w-[80%] rounded-2xl px-4 py-3 ${
                      msg.role === 'user'
                        ? 'bg-primary-600 text-white'
                        : 'bg-gray-100 dark:bg-gray-800 text-gray-900 dark:text-gray-100'
                    }`}
                  >
                    {msg.role === 'assistant' && (
                      <div className="flex items-center gap-2 mb-2">
                        <div className="h-6 w-6 rounded-full bg-gradient-to-br from-primary-500 to-accent-500 flex items-center justify-center">
                          <Bot className="h-4 w-4 text-white" />
                        </div>
                        <span className="font-medium text-sm">Aelita</span>
                      </div>
                    )}
                    <p className="whitespace-pre-wrap">{msg.content}</p>
                  </div>
                </div>
              ))}
            </CardBody>

            {/* Input area */}
            <div className="border-t border-gray-200 dark:border-gray-700 p-4">
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                  handleSend();
                }}
                className="flex gap-3"
              >
                <Input
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  placeholder="Ask Aelita anything about your projects..."
                  className="flex-1"
                />
                <Button type="submit" rightIcon={<Send className="h-4 w-4" />}>
                  Send
                </Button>
              </form>
              <p className="text-xs text-gray-400 mt-2 text-center">
                Aelita can help with project insights, team analysis, and generating reports.
              </p>
            </div>
          </Card>
        </div>
      </PageContainer>
    </>
  );
}
